import React from 'react';
import { Banner, Spacer, Text } from '@zillow/constellation';
import type { AbadContentProps } from '../types/@zillow-types';
import styled from 'styled-components';

const StyledWrapper = styled.div<{ isModal: boolean }>`
    // Similar to the form content height:
    max-height: 350px;
    overflow-y: ${(props) => (props.isModal ? 'visible' : 'auto')};
`;

const AbadContent = ({ abadHtml, isModal }: AbadContentProps) => (
    <StyledWrapper isModal={isModal} data-testid="contact-agent-abad">
        <Spacer marginBottom="sm">
            <Banner
                appearance="info"
                body={
                    <React.Fragment>
                        <strong>What&apos;s This?</strong> Zillow has affiliated businesses that
                        help make home buying and selling easier. You have not agreed to work with
                        any of these affiliates, this is only meant to inform you in case you want
                        to in the future.
                    </React.Fragment>
                }
            />
        </Spacer>
        <Text>
            {/* eslint-disable-next-line zillow/react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: abadHtml }} />
        </Text>
    </StyledWrapper>
);

export default AbadContent;
